import { useragentParser } from "../utils/useragent.js";

class Environment {
  web = false;

  constructor() {
    if (typeof window === "undefined") {
      return;
    }

    this.web = true;
    this.platform = useragentParser.getPlatform();
    this.os = useragentParser.getOS();
    this[this.platform] = true;
    this.motion = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "reduced" : "full";
  }
}

const environment = new Environment();
export { Environment as Env, environment as env };